import React from "react";
import PortfolioAllocationChart from "../../../Reusable/PortfolioAllocationChart";
import { useState, useEffect } from "react";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";

const PortfolioAllocation = ({ portfolioAllocationData }) => {
  const [type, setType] = useState("Conservative");
  // const [portfolioAllocationData, setPortfolioAllocationData] = useState([]);
  const [userPortfolio, setUserPortfolio] = useState();
  const [portfolioType, setPortfolioType] = useState();

  const handleChange = (prop) => {
    setType(prop);
  };
  // useEffect(() => {
  //   let familyId = UserStore?.userData?.family_id;
  //   let userId = UserStore?.userData?.user_id;
  //   if (familyId) {
  //     setCookie("familyId", familyId);
  //   } else {
  //     familyId = getCookie("familyId");
  //   }
  //   if (!userId) {
  //     userId = getCookie("userid");
  //   }
  //   AnalyticsStore.setOverall({
  //     ...AnalyticsStore.overall,
  //     portfolioAllocation: [],
  //     portfolioAllocationLoading: false,
  //   });
  //   getPortfolioAllocation(familyId, userId).then((response) => {
  //     AnalyticsStore.setOverall({
  //       ...AnalyticsStore.overall,
  //       portfolioAllocation: response.data,
  //       portfolioAllocationLoading: false,
  //     });
  //     setPortfolioAllocationData(response.data);
  //   });
  // }, [storeUserId]);

  useEffect(() => {
    portfolioAllocationData.map((single) => {
      if (single.portfolioType === "User") {
        setUserPortfolio(single);
      }
      if (single.portfolioType === type) {
        setPortfolioType(single);
        return false;
      }
      return false;
    });
  }, [portfolioAllocationData, type]);

  // useEffect(() => {
  //   portfolioAllocationData.map((single) => {
  //     if (single.portfolioType === "User") {
  //       setUserPortfolio(single);
  //     }
  //     if (single.portfolioType === type) {
  //       setPortfolioType(single);
  //       return;
  //     }
  //   });
  // }, [type]);

  const allObjectsHaveEmptyArray =
    AnalyticsStore.overall.portfolioAllocation?.every((obj) => {
      return (
        Array.isArray(obj.assetClassAllocations) &&
        obj.assetClassAllocations.length === 0
      );
    });

  const color = {
    model: "#35335a",
    portfolio: "#d3ac5d",
  };

  return (
    <>
      <h2
        className="performers asset_allocation_text"
        style={{ lineHeight: "27.5px" }}
      >
        Your Portfolio Allocation vs a <b>Model Portfolio</b>
      </h2>
      {!allObjectsHaveEmptyArray ? (
        <>
          <div className="choose_portfolio_type">
            <p
              style={{
                fontSize: "14px",
                lineHeight: "25.2px",
                fontWeight: 500,
                marginRight: "10px",
              }}
            >
              Choose a model Portfolio Type
            </p>
            <div className="p-type">
              <button
                onClick={() => handleChange("Conservative")}
                style={{
                  fontWeight: "400",
                  size: "14px",
                  lineHeight: "20px",
                }}
                className={
                  type === "Conservative" ? "active-type" : "non_active_type"
                }
              >
                Conservative
              </button>
              <button
                onClick={() => handleChange("Moderate")}
                className={
                  type === "Moderate" ? "active-type" : "non_active_type"
                }
                style={{
                  fontWeight: "400",
                  size: "14px",
                  lineHeight: "20px",
                  color: "#060F1F",
                }}
              >
                Moderate
              </button>
              <button
                onClick={() => handleChange("Aggressive")}
                className={
                  type === "Aggressive" ? "active-type" : "non_active_type"
                }
                style={{
                  fontWeight: "400",
                  size: "14px",
                  lineHeight: "20px",
                  color: "#060F1F",
                }}
              >
                Aggressive
              </button>
            </div>
          </div>

          <div style={{ width: "100%", height: "", padding: "0px" }}>
            <div className="portfolio_label_section">
              <div>
                <div
                  style={{ backgroundColor: color.portfolio }}
                  className="PA_portfolio_legent"
                />
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "19.6px",
                    fontWeight: 400,
                    marginLeft: "5px",
                  }}
                >
                  Portfolio
                </p>
              </div>
              <div style={{ marginLeft: "2.5%" }}>
                <div
                  style={{ backgroundColor: color.model }}
                  className="PA_portfolio_legent"
                />

                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "19.6px",
                    fontWeight: 400,
                    marginLeft: "5px",
                  }}
                >
                  Model
                </p>
              </div>
            </div>
            {userPortfolio && portfolioType ? (
              <PortfolioAllocationChart
                portfolioType={portfolioType}
                userPortfolio={userPortfolio}
                color={color}
              />
            ) : (
              <EmptyScreen
                loading={AnalyticsStore.overall.portfolioAllocationLoading}
              />
            )}
          </div>
        </>
      ) : (
        <EmptyScreen loading={false} />
      )}
    </>
  );
};

export default PortfolioAllocation;
